__turbopack_context__.v({
  "container": "gallery-module__cE6RTq__container",
  "dot": "gallery-module__cE6RTq__dot",
  "dots": "gallery-module__cE6RTq__dots",
  "missing": "gallery-module__cE6RTq__missing",
  "selected": "gallery-module__cE6RTq__selected",
  "wrapper": "gallery-module__cE6RTq__wrapper",
});
